// frontend/src/components/badges/BadgeItem.tsx

import { AchievementWithStatus } from '../../types/badge.types';

interface BadgeItemProps {
  badge: AchievementWithStatus;
}

export function BadgeItem({ badge }: BadgeItemProps) {
  return (
    <div className={`badge-item ${badge.earned ? '' : 'locked'}`} title={badge.description ?? undefined}>
      <div className="badge-icon">{badge.icon ?? '🏆'}</div>
      <div className="badge-name">{badge.title}</div>
      <div className="badge-desc">{badge.description}</div>
      {badge.earned && <div className="badge-xp-tag">+{badge.xp_reward} XP</div>}
    </div>
  );
}
